/* eslint-disable react-hooks/exhaustive-deps */
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Checkbox, Radio } from "@mui/material";
import {
  clone,
  cloneDeep,
  differenceWith,
  findIndex,
  isEqual,
  sortBy,
  groupBy,
  chain,
  sumBy,
  uniq,
} from "lodash";
import React, { useState, useEffect } from "react";
import attendanceConfigurationImg from "../../Assets/Images/Common/attendanceConfiguration.svg";
import SelectSalesCp from "../../Components/SelectSalesCp/SelectSalesCp";
import {
  getAllEventTokenAlgos,
  getAllEventTokens,
  updateEventTokens,
} from "../../Services/EventTokens";
import { errorTost, successTost } from "../../Services/Toast";
import Button from "../../Subcomponents/Button";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import ProgressCard from "../../Subcomponents/ProgressCard";
import TabsMenu from "../../Subcomponents/TabsMenu";
import cssClasses from "./AttendanceConfiguration.module.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import dragdrop from "../../Assets/Images/Common/dragdrop.svg";
import SearchBar from "../../Subcomponents/Search";
import DropDown from "../../Subcomponents/DropDown";
import Datagrid from "../../Subcomponents/Datagrid";
import {
  getEventTokenLeadRelations,
  updateEventLeadTokenGroup,
} from "../../Services/AssignNewToken";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import GroupNameModal from "../../Subcomponents/GroupNameModal/GroupNameModal";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  deleteGroup,
  getGroups,
  insertGroup,
  updateGroup,
} from "../../Services/EventQueue";
import DeleteIcon from "@mui/icons-material/Delete";
import { getEvent, updateEvent } from "../../Services/Event";
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import {
  findTotalLeadInGroupForThatEvent,
  getLeadsForFirstPay,
  updateLeadTokenRelationTable,
  updateRunningNumber,
} from "../../Services/Queue";
import { dismissLoader, presentLoader } from "../../Services/loader";

export default function AttendanceConfiguration() {
  const params = useParams();
  const eventId = params.eventId;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const submenu = searchParams.get("submenu");
  const dispatch = useDispatch();
  const [openAlert, setOpenAlert] = useState(false);
  const [flag, setFlag] = useState(false);
  const [tokenChanged, setTokenChanged] = useState(false);
  const [allEventTokens, setAllEventTokens] = useState([]);
  const [allChildEventTokens, setAllChildEventTokens] = useState([]);
  const [searchEventToken, setSearchEventToken] = useState("");
  const [searchToken, setSearchToken] = useState("");
  const [searchLead, setSearchLead] = useState("");
  const [groupName, setGroupName] = useState("");
  const [groupNameModal, setGroupNameModal] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(0);
  const [tokenOrder, setTokenOrder] = useState([]);
  const [algos, setAlgos] = useState([]);
  const [tokenFilter, setTokenFilter] = useState("");
  const [expanded, setExpanded] = useState("");
  const [leadList, setLeadList] = useState([]);
  const [childLeadList, setChildLeadList] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [allChildGroups, setAllChildGroups] = useState([]);
  const [event, setEvent] = useState(null);

  const [attendanceConfiguration, setAttendanceConfiguration] = useState({
    title: "Create a launch",
    totalProgress: 5,
    currentProgress: 0,
    timeline: [
      {
        text: "Select Tokens For Attendance",
        value: "Select Tokens For Attendance",
        isSelected: true,
      },
      { text: "Arrange Token", value: "Arrange Token", isSelected: false },
      {
        text: "Select Queue Order",
        value: "Select Queue Order",
        isSelected: false,
      },
      { text: "Select Cp/Sales", value: "Select Cp/Sales", isSelected: false },
      { text: "Change Priority", value: "Change Priority", isSelected: false },
    ],
    image: attendanceConfigurationImg,
  });

  const leadColumns = [
    {
      field: "leadName",
      headerName: "Lead Name",
      width: 400,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>
              <Checkbox
                checked={params.row?.isSelected}
                onChange={(e) => {
                  setChildLeadList((pre) => {
                    if (pre[pre.findIndex((e) => e.id === params.row.id)].isSelected) {
                      pre[pre.findIndex((e) => e.id === params.row.id)].groupName = ''
                      pre[pre.findIndex((e) => e.id === params.row.id)].groupId = ''
                    }
                    pre[pre.findIndex((e) => e.id === params.row.id)].isSelected =
                      !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected;
                    return [...pre];
                  });
                  setLeadList((pre) => {
                    pre[pre.findIndex((e) => e.id === params.row.id)].isSelected =
                      !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected;
                    return [...pre];
                  });
                }}
              />
            </div>
            <div>
              <p>{params.row.leadName}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: "cpName",
      headerName: "Cp Name",
      width: 250,
    },
    {
      field: "salesName",
      headerName: "Sales Name",
      width: 250,
    },
  ];

  const eventTokenGridColumns = [
    {
      field: "tokenName",
      headerName: "Token Name",
      width: 400,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>
              <Checkbox
                checked={params.row?.attendance}
                onChange={(e) => {
                  setAllChildEventTokens((pre) => {
                    pre[
                      pre.findIndex((e) => e.id === params.row.id)
                    ].attendance =
                      !pre[pre.findIndex((e) => e.id === params.row.id)]
                        .attendance;
                    pre[
                      pre.findIndex((e) => e.id === params.row.id)
                    ].isSelected =
                      !pre[pre.findIndex((e) => e.id === params.row.id)]
                        .isSelected;
                    return [...pre];
                  });
                }}
              />
            </div>
            <div>
              <p>{params.row.tokenId.name}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: "prerequisiteName",
      headerName: "Prerequisite",
      width: 250,
      renderCell: (params) => (
        <div>
          <p>
            {params.row.prerequisiteId ? (
              <span>
                {
                  allEventTokens[
                    allEventTokens.findIndex(
                      (e) => e.id === params.row.prerequisiteId.eventTokenId
                    )
                  ]?.tokenId?.name
                }
              </span>
            ) : (
              <span>-</span>
            )}
          </p>
        </div>
      ),
    },
    {
      field: "validityDays",
      headerName: "Validity",
      width: 250,
      renderCell: (params) => (
        <div>
          <p>{params.row.tokenId.validity} days</p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    tabChanged("", submenu);
  }, [submenu]);

  useEffect(() => {
    dispatch(action.activeMenu("ConfigureEvent"));
    getEvent(eventId).then((resp) => {
      console.log(resp[0]);
      resp[0].attendanceCompletedTabs = resp[0].attendanceCompletedTabs
        ? resp[0].attendanceCompletedTabs
        : [];
      setEvent(resp[0]);
    });
  }, []);

  useEffect(() => {
    setAttendanceConfiguration((pre) => {
      console.log(event?.attendanceCompletedTabs.length);
      pre.currentProgress = uniq(event?.attendanceCompletedTabs).length;
      pre.timeline.forEach((ele) => {
        if (event?.attendanceCompletedTabs.includes(ele.text)) {
          ele.isCompleted = true;
        }
      });
      return { ...pre };
    });
  }, [event]);

  useEffect(() => {
    if (
      attendanceConfiguration.timeline[0].isSelected === true ||
      attendanceConfiguration.timeline[1].isSelected === true
    ) {
      if (allEventTokens.length === 0) {
        presentLoader()
        getAllEventTokens(eventId).then((resp) => {
          if (resp.data.length === 0) {
            errorTost("Please complete token configuration to proceed")
            dismissLoader()
          } else {
            if (
              resp.data.filter((e) => {
                return e.attendance === true;
              }).length === 0
            ) {
              resp.data.forEach((ele, index) => {
                ele.label = ele.tokenId.name;
                ele.value = ele.tokenId.name;
                ele.id = ele.eventTokenId;
                ele.index = index;
                ele.show = true;
                ele.priority = index;
              });
            } else {
              resp.data.forEach((ele, index) => {
                ele.label = ele.tokenId.name;
                ele.value = ele.tokenId.name;
                ele.id = ele.eventTokenId;
                ele.index = index;
                ele.show = true;
              });
            }
            resp.data = sortBy(resp.data, [
              function (o) {
                return !o.attendance;
              },
            ]);
            let arr = cloneDeep(resp.data);
            setTokenFilter(arr[0].tokenId.name);
            setAllEventTokens([...arr]);
            setAllChildEventTokens([...resp.data]);
            setTokenOrder(
              sortBy(
                arr.filter((e) => {
                  return e.attendance === true;
                }),
                "priority"
              )
            );
            if (flag) {
              setFlag(false);
              setAttendanceConfiguration((pre) => {
                pre.timeline[0].isSelected = false;
                pre.timeline[1].isSelected = true;
                return { ...pre };
              });
              searchParams.set("submenu", "Arrange Token");
              setSearchParams(searchParams);
            }
            dismissLoader()
            // setAllChildEventTokens(sortBy(allChildEventTokens, [function (o) { return !o.attendance }]))
          }
        });
      } else {
        if (searchEventToken === "") {
          allChildEventTokens.forEach((e, index) => {
            setAllChildEventTokens((pre) => {
              pre[index].show = true;
              return [...pre];
            });
          });
          allEventTokens.forEach((e, index) => {
            setAllEventTokens((pre) => {
              pre[index].show = true;
              return [...pre];
            });
          });
        } else {
          allEventTokens.forEach((ele) => {
            if (
              !ele.tokenId.name
                .toUpperCase()
                .includes(searchEventToken.toUpperCase())
            ) {
              setAllChildEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = false;
                return [...pre];
              });
              setAllEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = false;
                return [...pre];
              });
            } else {
              setAllChildEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = true;
                return [...pre];
              });
              setAllEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = true;
                return [...pre];
              });
            }
          });
          setAllChildEventTokens(
            sortBy(allChildEventTokens, [
              function (o) {
                return !o.attendance;
              },
            ])
          );
        }
      }
    }
  }, [attendanceConfiguration, searchEventToken, flag]);

  useEffect(() => {
    if (attendanceConfiguration.timeline[2].isSelected === true) {
      if (algos.length === 0) {
        presentLoader()
        getAllEventTokenAlgos().then((resp) => {
          setAlgos([...resp.data]);
          dismissLoader()
        });
      } else {
        if (searchToken === "") {
          allChildEventTokens.forEach((e, index) => {
            setAllChildEventTokens((pre) => {
              pre[index].show = true;
              return [...pre];
            });
          });
          allEventTokens.forEach((e, index) => {
            setAllEventTokens((pre) => {
              pre[index].show = true;
              return [...pre];
            });
          });
        } else {
          allEventTokens.forEach((ele) => {
            if (
              !ele.tokenId.name
                .toUpperCase()
                .includes(searchToken.toUpperCase())
            ) {
              setAllChildEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = false;
                return [...pre];
              });
              setAllEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = false;
                return [...pre];
              });
            } else {
              setAllChildEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = true;
                return [...pre];
              });
              setAllEventTokens((pre) => {
                pre[
                  pre.findIndex((e) => e.tokenId.name === ele.tokenId.name)
                ].show = true;
                return [...pre];
              });
            }
          });
          setAllChildEventTokens(
            sortBy(allChildEventTokens, [
              function (o) {
                return !o.attendance;
              },
            ])
          );
        }
      }
    }
  }, [attendanceConfiguration, searchToken]);

  useEffect(() => {
    if (
      attendanceConfiguration.timeline[3].isSelected === true ||
      attendanceConfiguration.timeline[4].isSelected === true
    ) {
      if (allGroups.length === 0 && leadList.length === 0) {
        presentLoader()
        getEventTokenLeadRelations(eventId).then((tokenresp) => {
          getGroups(eventId).then((grpres) => {
            if (
              grpres.length === 0 &&
              attendanceConfiguration.timeline[4].isSelected === true
            ) {
              errorTost("Please create groups to change priority");
              setAttendanceConfiguration((pre) => {
                pre.timeline[4].isSelected = false;
                pre.timeline[3].isSelected = true;
                return { ...pre };
              });
            }
            grpres = sortBy(grpres, "groupPriority");
            grpres.forEach((e, i) => {
              e.groupPriority = i;
            });
            console.log(grpres, tokenresp);
            tokenresp.forEach((e, i) => {
              console.log(e);
              e.show = true;
              e.isSelected = false;
              e.id = e.paymentId;
              e.leadName = e.leadId.personId.name;
              e.cpName = e.leadId.cpId?.billingName;
              e.salesName = e.leadId.userId.name;
              e.tokenName = e.eventTokenId.tokenId.name;
              e.groupName = e.groupId?.groupName;
              e.groupId = e.groupId?.groupId;
              // e.groupPriority = i
              if (e.groupId && e.groupId !== "") {
                if (
                  grpres[grpres.findIndex((ele) => ele.groupId === e.groupId)]
                    .leads
                ) {
                  grpres[
                    grpres.findIndex((ele) => ele.groupId === e.groupId)
                  ].leads.push(e);
                } else {
                  grpres[
                    grpres.findIndex((ele) => ele.groupId === e.groupId)
                  ].leads = [e];
                }
              }
            });
            // tokenresp = tokenresp.filter((e) => { return !e.groupId || e.groupId === '' })
            setLeadList(cloneDeep([...tokenresp]));
            let array = tokenresp.filter((e) => {
              return (
                e.eventTokenId.tokenId.name
                  .toUpperCase()
                  .includes(tokenFilter.toUpperCase()) &&
                (!e.groupId || e.groupId === "")
              );
            });
            let arr = cloneDeep(array);
            setChildLeadList(cloneDeep([...arr]));
            // sortBy(grpres, 'groupPriority')
            setAllGroups([...grpres]);
            let arr1 = cloneDeep(grpres);
            setAllChildGroups([...arr1]);
            dismissLoader()
          });
        });
      } else {
        // if (allGroups.length > 0) {
        //     allGroups.forEach((e, index) => {
        //         setAllGroups((pre) => { pre.groupPriority = index; return [...pre] })
        //     })
        // }
        console.log(leadList);
        setChildLeadList(
          cloneDeep([
            ...leadList.filter((e) => {
              return (
                (e.groupName === "" || !e.groupName) &&
                e.eventTokenId.tokenId.name
                  .toUpperCase()
                  .includes(tokenFilter.toUpperCase())
                &&
                (e.cpName?.toUpperCase().includes(searchLead.toUpperCase()) ||
                  e.salesName
                    .toUpperCase()
                    .includes(searchLead.toUpperCase()) ||
                  e.leadName.toUpperCase().includes(searchLead.toUpperCase()))
              );
            }),
          ])
        );
      }
    }
  }, [attendanceConfiguration, searchLead, tokenFilter]);

  function tabChanged(e, value) {
    let tabIndex = attendanceConfiguration.timeline.findIndex(
      (e) => e.value === value
    );
    // if (allChildGroups.length === 0 && tabIndex === 4) {
    //     errorTost("Please create and save groups and then continue")
    // } else
    if (
      allEventTokens.filter((e) => {
        return e.attendance === true;
      }).length === 0 &&
      tabIndex > 0
    ) {
      errorTost(
        "Please select and save tokens for attendance and then continue"
      );
      searchParams.set("submenu", "Select Tokens For Attendance");
      setSearchParams(searchParams);
    } else {
      if (attendanceConfiguration.timeline[0].isSelected === true) {
        console.log(tokenOrder);
        if (!isEqual(allChildEventTokens, allEventTokens) && tabIndex !== 0) {
          setClickedIndex(tabIndex);
          setOpenAlert(true);
          searchParams.set('submenu', 'Select Tokens For Attendance')
          setSearchParams(searchParams)
        } else {
          if (tabIndex !== 0) {
            setSearchEventToken("");
          }
          setAttendanceConfiguration((pre) => {
            pre.timeline[0].isSelected = false;
            pre.timeline[tabIndex].isSelected = true;
            return { ...pre };
          });
        }
      } else if (attendanceConfiguration.timeline[1].isSelected === true) {
        // tokenOrder.forEach((ele, index) => {
        for (let index = 0; index < tokenOrder.length; index++) {
          console.log(
            tokenOrder[index].name,
            index,
            tokenOrder[index].priority
          );
          if (tokenOrder[index].priority !== index && tabIndex !== 1) {
            setClickedIndex(tabIndex);
            setOpenAlert(true);
            break;
            searchParams.set('submenu', 'Arrange Token')
            setSearchParams(searchParams)
          } else {
            if (index === tokenOrder.length - 1) {
              setAttendanceConfiguration((pre) => {
                pre.timeline[1].isSelected = false;
                pre.timeline[tabIndex].isSelected = true;
                return { ...pre };
              });
            }
          }
        }
        // })
      } else if (attendanceConfiguration.timeline[2].isSelected === true) {
        let child = allChildEventTokens.filter((e) => {
          return e.algoId && e.algoId !== "";
        });
        let parent = allEventTokens.filter((e) => {
          return e.algoId && e.algoId !== "";
        });
        if (!isEqual(parent, child) && tabIndex !== 2) {
          setClickedIndex(tabIndex);
          setOpenAlert(true);
          searchParams.set('submenu', 'Select Queue Order')
          setSearchParams(searchParams)
        } else {
          if (tabIndex !== 2) {
            setSearchToken("");
          }
          setAttendanceConfiguration((pre) => {
            pre.timeline[2].isSelected = false;
            pre.timeline[tabIndex].isSelected = true;
            return { ...pre };
          });
        }
      } else if (attendanceConfiguration.timeline[3].isSelected === true) {
        if (!isEqual(allChildGroups, allGroups) && tabIndex !== 3) {
          setClickedIndex(tabIndex);
          setOpenAlert(true);
          searchParams.set('submenu', 'Select Cp/Sales')
          setSearchParams(searchParams)
        } else {
          if (tabIndex !== 3) {
            setSearchLead("");
          }
          setAttendanceConfiguration((pre) => {
            pre.timeline[3].isSelected = false;
            pre.timeline[tabIndex].isSelected = true;
            return { ...pre };
          });
        }
      } else if (attendanceConfiguration.timeline[4].isSelected === true) {
        if (allChildGroups.length === 0) {
          setAttendanceConfiguration((pre) => {
            pre.timeline[4].isSelected = false;
            pre.timeline[tabIndex].isSelected = true;
            return { ...pre };
          });
        } else {
          for (let index = 0; index < allChildGroups.length; index++) {
            console.log(index, allChildGroups[index].groupPriority);
            if (allChildGroups[index].groupPriority !== index && tabIndex !== 4) {
              setClickedIndex(tabIndex);
              setOpenAlert(true);
              searchParams.set('submenu', 'Change Priority')
              setSearchParams(searchParams)
              break;
            } else {
              if (index === allChildGroups.length - 1) {
                setAttendanceConfiguration((pre) => {
                  pre.timeline[4].isSelected = false;
                  pre.timeline[tabIndex].isSelected = true;
                  return { ...pre };
                });
              }
            }
          }
        }
        // allGroups.forEach((ele, index) => {
        //     console.log(ele.name, index, ele.groupPriority)
        //     if (ele.groupPriority !== index) {
        //         setClickedIndex(tabIndex)
        //         setOpenAlert(true)
        //     } else {
        //         if (index === allGroups.length - 1) {
        //             setAttendanceConfiguration((pre) => { pre.timeline[4].isSelected = false; pre.timeline[tabIndex].isSelected = true; return { ...pre } })
        //         }
        //     }
        // })
      } else {
        setAttendanceConfiguration((pre) => {
          pre.timeline[
            attendanceConfiguration.timeline.findIndex(
              (e) => e.isSelected === true
            )
          ].isSelected = false;
          pre.timeline[tabIndex].isSelected = true;
          return { ...pre };
        });
      }
    }
  }

  function nextStep() {
    if (
      attendanceConfiguration.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Select Tokens For Attendance"
    ) {
      let arr = allChildEventTokens.filter((e) => {
        return e.attendance === true;
      });
      if (arr.length === 0) {
        let newarr = cloneDeep(allEventTokens);
        setAllChildEventTokens([...newarr]);
        errorTost("Please select atleast one Token and then save");
        searchParams.set("submenu", "Select Tokens For Attendance");
        setSearchParams(searchParams);
      } else {
        let i = 0;
        presentLoader()
        allChildEventTokens.forEach((ele, arrindex) => {
          let obj = cloneDeep(ele);
          if (obj.attendance === false) {
            obj.priority = 0;
            obj.algoId = null;
          } else {
            obj.priority = i;
            i = i + 1;
          }
          delete obj.id;
          delete obj.show;
          delete obj.index;
          obj.tokenId = obj.tokenId.tokenId;
          delete obj.label;
          delete obj.value;
          delete obj.isSelected;
          delete obj.EventTokensLaunchRelations;
          console.log(obj);
          obj.prerequisiteId = obj.prerequisiteId?.eventTokenId
            ? obj.prerequisiteId.eventTokenId
            : null;
          updateEventTokens(obj).then((resp) => {
            if (arrindex === allChildEventTokens.length - 1) {
              if (
                !event.attendanceCompletedTabs.includes(
                  "Select Tokens For Attendance"
                )
              ) {
                let obj = cloneDeep(event);
                obj.attendanceCompletedTabs.push(
                  "Select Tokens For Attendance"
                );
                updateEvent(eventId, obj).then((resp) => {
                  setEvent((pre) => {
                    pre.attendanceCompletedTabs.push(
                      "Select Tokens For Attendance"
                    );
                    return { ...pre };
                  });
                });
              }
              // setTokenOrder(sortBy(arr.filter((e) => { return e.attendance === true }), 'priority'))
              setAllEventTokens([]);
              setSearchEventToken("");
              successTost("Tokens saved successfully");
              // let newarr = cloneDeep(allChildEventTokens)
              // setAllEventTokens([...newarr])
              setFlag(true);
              dismissLoader()
            }
          });
        });
      }
    } else if (
      attendanceConfiguration.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Arrange Token"
    ) {
      presentLoader()
      tokenOrder.forEach((ele, index) => {
        let obj = cloneDeep(ele);
        obj.priority = index;
        delete obj.id;
        delete obj.show;
        delete obj.index;
        obj.tokenId = obj.tokenId.tokenId;
        delete obj.label;
        delete obj.value;
        delete obj.EventTokensLaunchRelations;
        obj.prerequisiteId = obj.prerequisiteId?.eventTokenId
          ? obj.prerequisiteId.eventTokenId
          : null;
        updateEventTokens(obj).then((resp) => {
          setTokenOrder((pre) => {
            pre[index].priority = index;
            return [...pre];
          });
          if (index === tokenOrder.length - 1) {
            if (!event.attendanceCompletedTabs.includes("Arrange Token")) {
              let obj = cloneDeep(event);
              obj.attendanceCompletedTabs.push("Arrange Token");
              updateEvent(eventId, obj).then((resp) => {
                setEvent((pre) => {
                  pre.attendanceCompletedTabs.push("Arrange Token");
                  return { ...pre };
                });
              });
            }
            setTokenOrder(sortBy(tokenOrder, "priority"));
            let newarr = cloneDeep(allChildEventTokens);
            setAllEventTokens([...newarr]);
            setAttendanceConfiguration((pre) => {
              pre.timeline[1].isSelected = false;
              pre.timeline[2].isSelected = true;
              return { ...pre };
            });
            successTost("Tokens arranged successfully");
            searchParams.set("submenu", "Select Queue Order");
            setSearchParams(searchParams);
            dismissLoader()
          }
        });
      });
    } else if (
      attendanceConfiguration.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Select Queue Order"
    ) {
      let arr = allChildEventTokens.filter((e) => {
        return e.algoId && e.algoId !== "";
      });
      if (arr.length > 0) {
        presentLoader()
        allChildEventTokens.forEach((ele, index) => {
          let obj = cloneDeep(ele);
          obj.priority = index;
          delete obj.id;
          delete obj.show;
          delete obj.index;
          obj.tokenId = obj.tokenId.tokenId;
          delete obj.label;
          delete obj.value;
          delete obj.EventTokensLaunchRelations;
          obj.prerequisiteId = obj.prerequisiteId?.eventTokenId
            ? obj.prerequisiteId.eventTokenId
            : null;
          updateEventTokens(obj).then((resp) => {
            if (index === allChildEventTokens.length - 1) {
              if (
                !event.attendanceCompletedTabs.includes("Select Queue Order")
              ) {
                let obj = cloneDeep(event);
                obj.attendanceCompletedTabs.push("Select Queue Order");
                updateEvent(eventId, obj).then((resp) => {
                  setEvent((pre) => {
                    pre.attendanceCompletedTabs.push("Select Queue Order");
                    return { ...pre };
                  });
                });
              }
              let newarr = cloneDeep(allChildEventTokens);
              setAllEventTokens([...newarr]);
              setAttendanceConfiguration((pre) => {
                pre.timeline[2].isSelected = false;
                pre.timeline[3].isSelected = true;
                return { ...pre };
              });
              setSearchToken("");
              successTost("Token queue order saved successfully");
              searchParams.set("submenu", "Select Cp/Sales");
              setSearchParams(searchParams);
              dismissLoader()
            }
          });
        });
      } else {
        let arr = cloneDeep(allEventTokens);
        setAllChildEventTokens([...arr]);
        errorTost("Please select atleast one algorithm and then save");
      }
    } else if (
      attendanceConfiguration.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Select Cp/Sales"
    ) {

      // let newarr = cloneDeep(allChildSales)
      // setAllSales([...newarr])
      let parent = cloneDeep([...allGroups]);
      let child = cloneDeep([...allChildGroups]);
      child.forEach((e) => {
        delete e.leads;
      });
      parent.forEach((e) => {
        delete e.leads;
      });
      console.log(child);
      console.log(parent);
      let insertarr = differenceWith(child, parent, isEqual);
      let deletearr = differenceWith(parent, child, isEqual);
      console.log("insertarr", insertarr);
      console.log("deletearr", deletearr);
      if (insertarr.length > 0) {
        presentLoader()
        insertarr.forEach((element, index) => {
          element = allChildGroups.filter((f) => {
            return f.groupName === element.groupName;
          })[0];
          console.log(element);
          let obj = cloneDeep(element);
          delete obj.leads;
          delete obj.id;
          insertGroup(obj).then((resp) => {
            console.log(element.leads);
            element.leads.forEach((insertLead) => {
              updateEventLeadTokenGroup(
                { groupId: resp[0].groupId },
                insertLead.paymentId
              ).then((updateRes) => {
                if (index === insertarr.length - 1) {
                  if (
                    !event.attendanceCompletedTabs.includes("Select Cp/Sales")
                  ) {
                    let obj = cloneDeep(event);
                    obj.attendanceCompletedTabs.push("Select Cp/Sales");
                    updateEvent(eventId, obj).then((resp) => {
                      setEvent((pre) => {
                        pre.attendanceCompletedTabs.push("Select Cp/Sales");
                        return { ...pre };
                      });
                    });
                  }
                  if (deletearr.length > 0) {
                    deletearr.forEach((ele, index2) => {
                      // ele = allGroups.filter((f) => {
                      //   return f.groupName === element.groupName;
                      // })[0];
                      // console.log(ele);
                      // ele.leads.forEach((deleteLead, i) => {
                      //   updateEventLeadTokenGroup(
                      //     { groupId: null },
                      //     deleteLead.paymentId
                      //   ).then((updateRes) => {
                      //     if (i === ele.leads.length - 1) {
                      deleteGroup(ele.groupId).then((deleteRes) => {
                        if (index2 === deletearr.length - 1) {
                          successTost("Groups saved successfully");
                          algoFirstPayFirstServe();
                          setAttendanceConfiguration((pre) => {
                            pre.timeline[4].isSelected = true;
                            pre.timeline[3].isSelected = false;
                            return { ...pre };
                          });
                          setSearchLead("");
                          setAllChildGroups([]);
                          setAllGroups([]);
                          setLeadList([]);
                          setChildLeadList([]);
                          searchParams.set("submenu", "Change Priority");
                          setSearchParams(searchParams);
                          dismissLoader()
                        }
                      });
                      //     }
                      //   });
                      // });
                    });
                  } else {
                    successTost("Groups saved successfully");
                    algoFirstPayFirstServe();
                    setAttendanceConfiguration((pre) => {
                      pre.timeline[4].isSelected = true;
                      pre.timeline[3].isSelected = false;
                      return { ...pre };
                    });
                    setSearchLead("");
                    setAllChildGroups([]);
                    setAllGroups([]);
                    setLeadList([]);
                    setChildLeadList([]);
                    searchParams.set("submenu", "Change Priority");
                    setSearchParams(searchParams);
                    dismissLoader()
                  }
                }
              });
            });
          });
          // .catch((e) => {
          //     if (e.message === 'duplicate key value violates unique constraint "eventQueue_pkey"') {
          //         element.leads.forEach((insertLead) => {
          //             updateEventLeadTokenGroup({ groupId: element.groupId }, insertLead.paymentId).then((updateRes) => {
          //                 if (index === insertarr.length - 1) {
          //                     if (deletearr.length > 0) {
          //                         deletearr.forEach((ele, index2) => {
          //                             ele.leads.forEach((deleteLead, i) => {
          //                                 updateEventLeadTokenGroup({ groupId: null }, deleteLead.paymentId).then((updateRes) => {
          //                                     if (i === ele.leads.length - 1) {
          //                                         deleteGroup(ele.groupId).then((deleteRes) => {
          //                                             if (index2 === deletearr.length - 1) {
          //                                                 successTost("Groups saved successfully")
          //                                                 setAttendanceConfiguration((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
          //                                                 setSearchLead('')
          //                                                 setAllChildGroups([])
          //                                                 setAllGroups([])
          //                                                 setLeadList([])
          //                                                 setChildLeadList([])
          //                                             }
          //                                         })
          //                                     }
          //                                 })
          //                             })
          //                         })
          //                     } else {
          //                         successTost("Groups saved successfully")
          //                         setAttendanceConfiguration((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
          //                         setSearchLead('')
          //                         setAllChildGroups([])
          //                         setAllGroups([])
          //                         setLeadList([])
          //                         setChildLeadList([])
          //                     }
          //                 }
          //             })
          //         })
          //     }
          // })
        });
      } else if (deletearr.length > 0) {
        deletearr.forEach((ele, index2) => {
          // ele = allGroups.filter((f) => {
          //   return f.groupName === ele.groupName;
          // })[0];
          // console.log(ele);
          // ele.leads.forEach((deleteLead, i) => {
          //   updateEventLeadTokenGroup(
          //     { groupId: null },
          //     deleteLead.paymentId
          //   ).then((updateRes) => {
          //     if (i === ele.leads.length - 1) {
          presentLoader()
          deleteGroup(ele.groupId).then((deleteRes) => {
            if (index2 === deletearr.length - 1) {
              successTost("Groups saved successfully");
              algoFirstPayFirstServe();
              setAttendanceConfiguration((pre) => {
                pre.timeline[4].isSelected = true;
                pre.timeline[3].isSelected = false;
                return { ...pre };
              });
              setSearchLead("");
              setAllChildGroups([]);
              setAllGroups([]);
              setLeadList([]);
              setChildLeadList([]);
              searchParams.set("submenu", "Change Priority");
              setSearchParams(searchParams);
              dismissLoader()
            }
          });
          //     }
          //   });
          // });
        });
      } else if (
        leadList.filter((e) => {
          return (
            e.groupName &&
            e.groupName !== "" &&
            (!e.groupId || e.groupId === "")
          );
        }).length > 0
      ) {
        leadList
          .filter((e) => {
            return (
              e.groupName &&
              e.groupName !== "" &&
              (!e.groupId || e.groupId === "")
            );
          })
          .forEach((ele, i) => {
            updateEventLeadTokenGroup(
              {
                groupId: allGroups.filter((grp) => {
                  return grp.groupName === ele.groupName;
                })[0].groupId,
              },
              ele.paymentId
            ).then((updateRes) => {
              if (
                i ===
                leadList.filter((e) => {
                  return (
                    e.groupName &&
                    e.groupName !== "" &&
                    (!e.groupId || e.groupId === "")
                  );
                }).length -
                1
              ) {
                successTost("Groups saved successfully");
                setAttendanceConfiguration((pre) => {
                  pre.timeline[4].isSelected = true;
                  pre.timeline[3].isSelected = false;
                  return { ...pre };
                });
                setSearchLead("");
                setAllChildGroups([]);
                setAllGroups([]);
                setLeadList([]);
                setChildLeadList([]);
                searchParams.set("submenu", "Change Priority");
                setSearchParams(searchParams);
              }
            });
          });
      } else if (
        leadList.filter((e) => {
          return (
            !e.groupName && e.groupName === "" && e.groupId && e.groupId !== ""
          );
        }).length > 0
      ) {
        leadList
          .filter((e) => {
            return (
              !e.groupName &&
              e.groupName === "" &&
              e.groupId &&
              e.groupId !== ""
            );
          })
          .forEach((ele, i) => {
            updateEventLeadTokenGroup({ groupId: null }, ele.paymentId).then(
              (updateRes) => {
                if (
                  i ===
                  leadList.filter((e) => {
                    return (
                      !e.groupName &&
                      e.groupName === "" &&
                      e.groupId &&
                      e.groupId !== ""
                    );
                  }).length -
                  1
                ) {
                  successTost("Groups saved successfully");
                  algoFirstPayFirstServe();
                  setAttendanceConfiguration((pre) => {
                    pre.timeline[4].isSelected = true;
                    pre.timeline[3].isSelected = false;
                    return { ...pre };
                  });
                  setSearchLead("");
                  setAllChildGroups([]);
                  setAllGroups([]);
                  setLeadList([]);
                  setChildLeadList([]);
                  searchParams.set("submenu", "Change Priority");
                  setSearchParams(searchParams);
                }
              }
            );
          });
      } else {
        if (allGroups.length === 0) {
          errorTost("Please create groups to change priority");
          setAttendanceConfiguration((pre) => {
            pre.timeline[4].isSelected = false;
            pre.timeline[3].isSelected = true;
            return { ...pre };
          });
        } else {
          successTost("Groups saved successfully");
          algoFirstPayFirstServe();
          setAttendanceConfiguration((pre) => {
            pre.timeline[4].isSelected = true;
            pre.timeline[3].isSelected = false;
            return { ...pre };
          });
          setSearchLead("");
          searchParams.set("submenu", "Change Priority");
          setSearchParams(searchParams);
        }
      }
    } else if (
      attendanceConfiguration.timeline.filter((e) => {
        return e.isSelected === true;
      })[0].text === "Change Priority"
    ) {

      let arr = cloneDeep(allChildGroups);
      console.log(arr);
      if(arr.length > 0) {
        presentLoader()
        arr.forEach((e, i) => {
          updateGroup({ groupPriority: i }, e.groupId).then((resp) => {
            if (i === allChildGroups.length - 1) {
              if (!event.attendanceCompletedTabs.includes("Change Priority")) {
                let obj = cloneDeep(event);
                obj.attendanceCompletedTabs.push("Change Priority");
                updateEvent(eventId, obj).then((resp) => {
                  setEvent((pre) => {
                    pre.attendanceCompletedTabs.push("Change Priority");
                    return { ...pre };
                  });
                });
              }
              successTost("Priority changed successfully");
              algoFirstPayFirstServe();
              navigate(`/home/Event/ConfigureEvent/${eventId}`);
              dismissLoader()
              // setAllGroups([...arr])
            }
          });
        });
      } else {
        navigate(`/home/Event/ConfigureEvent/${eventId}`);
      }
    }
  }

  function algoFirstPayFirstServe() {
    //only leads having  tokens  first pay first algo
    let leadsFirstPay = [];
    let leadsWithoutGroup = [];
    getLeadsForFirstPay(eventId, "Token Payment Complete")
      .then((leadResp) => {
        console.log(leadResp);
        leadResp.data = leadResp.data.map((resp) => ({
          ...resp,
          grpPriority: resp?.groupId?.groupPriority,
          eventTokenWise: resp?.eventTokenId?.eventTokenId
        }));
        leadResp.data.forEach((el) => {
          if (el?.leadId?.LeadStatus?.length > 0 && el?.eventTokenId?.algoId !== null) {
            leadsFirstPay.push(el);
          }
          //   if (el?.groupId === null) {
          //     leadsWithoutGroup.push(el);
          //   }
        });
        //**Leads in group by group priority all leads with or without groups handled in this loop
        let leadsInGroup = [];
        leadsInGroup = chain(leadsFirstPay)
          // Group the elements of Array based on `groupPriority` property
          .groupBy("grpPriority")
          // `key` is group's name (groupPriority), `value` is the array of objects
          .map((value, key) => ({ grpPriority: key, Leads: value }))
          .value();
        console.log({ leadsInGroup });
        // ** Group by eventTokenId
        let leadsEventTokenId = chain(leadsFirstPay)
          .groupBy("eventTokenWise")
          .map((value, key) => ({ eventTokenId: key, Leads: value }))
          .value();
        console.log({ leadsEventTokenId });

        for (let i = 0; i < leadsEventTokenId.length; i++) {
          let finalArray = chain(leadsEventTokenId[i].Leads)
            .groupBy("grpPriority")
            .map((value, key) => ({ grpPriority: key, Leads: value }))
            .value();
          leadsEventTokenId[i].grouped = finalArray
        }
        console.log('After', leadsEventTokenId);
        sortBy(leadsEventTokenId,)
        // EventIdGrouping
        for (let i = 0; i < leadsEventTokenId.length; i++) {
          let counted = 1;
          // LeadGroupings on same group
          for (let j = 0; j < leadsEventTokenId[i].grouped.length; j++) {
            //   Array of grouped with priority
            for (let k = 0; k < leadsEventTokenId[i].grouped[j].Leads.length; k++) {
              updateLeadTokenRelationTable(
                leadsEventTokenId[i].grouped[j].Leads[k]?.paymentId,
                counted,
                leadsEventTokenId[i].grouped[j].Leads[k]?.eventTokenId.tokenId?.shortCode +
                "-" +
                parseInt(counted)

              ).then((response) => {
                console.log(response);
              });
              counted = counted + 1;

            }


          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    //First Pay First
  }

  function changeToken(e) {
    setTokenChanged(false);
    if (e === "confirmed") {
      childLeadList.forEach((e, i) => {
        setChildLeadList((pre) => {
          pre[i].isSelected = false;
          return [...pre];
        });
      });
      leadList.forEach((e, i) => {
        setLeadList((pre) => {
          pre[i].isSelected = false;
          return [...pre];
        });
      });
    }
  }

  function ModalResp(e) {
    setOpenAlert(false);
    let index = attendanceConfiguration.timeline.findIndex(
      (e) => e.isSelected === true
    );
    if (e === "confirmed") {
      searchParams.set(
        "submenu",
        attendanceConfiguration.timeline[clickedIndex].value
      );
      setSearchParams(searchParams);
      if (index === 0) {
        setSearchEventToken("");
        let arr = cloneDeep(allEventTokens);
        setAllChildEventTokens([...arr]);
        setAttendanceConfiguration((pre) => {
          pre.timeline[clickedIndex].isSelected = true;
          pre.timeline[0].isSelected = false;
          return { ...pre };
        });
      } else if (index === 1) {
        setTokenOrder(sortBy(tokenOrder, "priority"));
        setAttendanceConfiguration((pre) => {
          pre.timeline[clickedIndex].isSelected = true;
          pre.timeline[1].isSelected = false;
          return { ...pre };
        });
      } else if (index === 2) {
        let arr = cloneDeep(allEventTokens);
        setSearchToken("");
        setAllChildEventTokens([...arr]);
        setAttendanceConfiguration((pre) => {
          pre.timeline[clickedIndex].isSelected = true;
          pre.timeline[2].isSelected = false;
          return { ...pre };
        });
      } else if (index === 3) {
        let arr = cloneDeep(allGroups);
        setAllChildGroups([...arr]);
        // let leadarr = cloneDeep([...leadList])
        // // let a = cloneDeep(leadList)
        // // console.log(a)
        // arr.forEach((grp)=>{
        //     grp.leads.forEach((lead)=>{
        //         [leadarr.findIndex((e)=>(e.paymentId = lead.paymentId))].groupId =
        //     })
        // })
        leadList.forEach((ele, index) => {
          if (!ele.groupId || ele.groupId === "")
            setLeadList((pre) => {
              pre[index].groupName = "";
              pre[index].priority = index;
              pre[index].isSelected = false;
              return [...pre];
            });
          else
            setLeadList((pre) => {
              pre[index].priority = index;
              pre[index].groupName =
                allGroups[
                  allGroups.findIndex((e) => (e.groupId = ele.groupId))
                ].groupName;
              return [...pre];
            });
        });
        let newarr = cloneDeep([...leadList]);
        newarr.forEach((ele, index) => {
          if (ele.groupId === "") {
            newarr[index].isSelected = false;
            newarr[index].groupName = "";
          } else newarr.splice(index, 1);
        });
        setChildLeadList(cloneDeep([...newarr]));
        setSearchLead("");
        setAttendanceConfiguration((pre) => {
          pre.timeline[3].isSelected = false;
          pre.timeline[clickedIndex].isSelected = true;
          return { ...pre };
        });
      } else if (index === 4) {
        // let arr = sortBy(allGroups, 'groupPriority')
        let arr = cloneDeep(allGroups);
        setAllChildGroups([...arr]);
        setAttendanceConfiguration((pre) => {
          pre.timeline[4].isSelected = false;
          pre.timeline[clickedIndex].isSelected = true;
          return { ...pre };
        });
      }
    } else {
      searchParams.set(
        "submenu",
        attendanceConfiguration.timeline[index].value
      );
      setSearchParams(searchParams);
      if (document.getElementById("algoSearchinput-with-icon-textfield")) {
        document.getElementById("algoSearchinput-with-icon-textfield").value =
          "";
      }
    }
  }

  useEffect(() => {
    console.log("child", allChildEventTokens);
    console.log("parent", allEventTokens);
  }, [allChildEventTokens, allGroups]);

  useEffect(() => {
    console.log("child", allChildGroups);
    console.log("parent", allGroups);
  }, [allChildGroups, allGroups]);

  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    let arr = tokenOrder;
    const [removed] = arr.splice(result.source.index, 1);
    arr.splice(result.destination.index, 0, removed);
    setTokenOrder([...arr]);
  }

  function onGrpDrag(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    let arr = allChildGroups;
    const [removed] = arr.splice(result.source.index, 1);
    arr.splice(result.destination.index, 0, removed);
    setAllChildGroups([...arr]);
  }

  function groupLeads() {
    if (
      childLeadList.filter((e) => {
        return e.isSelected === true;
      }).length === 0
    ) {
      errorTost("Please select Leads to group");
    } else {
      setGroupNameModal(true);
    }
  }

  function createGroup() {
    setGroupNameModal(false);
    let leadArr = cloneDeep([...childLeadList])
    leadArr.forEach((ele, index) => {
      if (ele.isSelected === true)
        setLeadList((pre) => {
          pre[index].groupName = groupName;
          pre[index].isSelected = false;
          return [...pre];
        });
    });
    let group = cloneDeep(
      leadArr.filter((ele) => {
        return ele.isSelected === true;
      })
    );
    let arr = cloneDeep(
      leadArr.filter((ele) => {
        return (
          ele.isSelected === false &&
          (!ele.groupName || ele.groupName === "") &&
          (!ele.groupId || ele.groupId === "")
        );
      })
    );
    let a = cloneDeep(
      arr.filter((ele) => {
        return ele.eventTokenId.tokenId.name
          .toUpperCase()
          .includes(tokenFilter.toUpperCase());
      })
    );
    setChildLeadList(cloneDeep([...a]));
    if (allChildGroups.length === 0) {
      setAllChildGroups((pre) => {
        pre.push({
          id: allChildGroups.length,
          tokenName: tokenFilter,
          tokenPriority:
            allEventTokens[
              allEventTokens.findIndex((e) => e.tokenId.name === tokenFilter)
            ].priority,
          algoId:
            allEventTokens[
              allEventTokens.findIndex((e) => e.tokenId.name === tokenFilter)
            ].algoId,
          eventId: eventId,
          eventTokenId: allEventTokens.find((e) => e.tokenId.name === tokenFilter).eventTokenId,
          runningNo: 0,
          groupName: groupName,
          totalLeadsInGroup: group.length,
          groupPriority: allChildGroups.length,
          leads: group,
        });
        return [...pre];
      });
    } else {
      let grp = allChildGroups.find((e) => e.groupName === groupName);
      if (grp) {
        setAllChildGroups((pre) => {
          pre[pre.findIndex((e) => e.groupName === groupName)].leads.push(
            ...group
          );
          return [...pre];
        });
      } else {
        setAllChildGroups((pre) => {
          pre.push({
            id: allChildGroups.length,
            tokenName: tokenFilter,
            tokenPriority:
              allEventTokens[
                allEventTokens.findIndex((e) => e.tokenId.name === tokenFilter)
              ].priority,
            algoId:
              allEventTokens[
                allEventTokens.findIndex((e) => e.tokenId.name === tokenFilter)
              ].algoId,
            eventId: eventId,
            eventTokenId: allEventTokens.find((e) => e.tokenId.name === tokenFilter).eventTokenId,
            runningNo: 0,
            groupName: groupName,
            totalLeadsInGroup: group.length,
            groupPriority: allChildGroups.length,
            leads: group,
          });
          return [...pre];
        });
      }
    }
    setGroupName("");
  }

  function deleteGrp(grp, i) {
    grp.leads.forEach((e) => {
      e.groupName = "";
      e.groupId = "";
      e.isSelected = false;
      // setLeadList((pre) => {
      //   pre[pre.findIndex((ele) => ele.paymentId === e.paymentId)].groupName =
      //     "";
      //   pre[pre.findIndex((ele) => ele.paymentId === e.paymentId)].groupId =
      //     "";
      //   pre[pre.findIndex((ele) => ele.paymentId === e.paymentId)].isSelected =
      //     false;
      //   return [...pre];
      // });
      if (e.tokenName.toUpperCase() === tokenFilter.toUpperCase()) {
        setChildLeadList((pre) => {
          pre.push(e);
          return [...pre];
        });
      }
    });
    setAllChildGroups((pre) => {
      pre.splice(i, 1);
      return [...pre];
    });
  }

  function deleteLeadFromGrp(grp, grpIndex, lead, leadIndex) {
    if (grp.leads.length === 1) {
      deleteGrp(grp, grpIndex);
    } else {
      setAllChildGroups((pre) => {
        pre[grpIndex].leads.splice(leadIndex, 1);
        return [...pre];
      });
      setLeadList((pre) => {
        pre[
          pre.findIndex((ele) => ele.paymentId === lead.paymentId)
        ].groupName = "";
        return [...pre];
      });
      if (lead.tokenName.toUpperCase() === tokenFilter.toUpperCase()) {
        lead.groupName = "";
        lead.isSelected = false;
        setChildLeadList((pre) => {
          pre.push(lead);
          return [...pre];
        });
      }
    }
  }

  function selectAll() {
    if (attendanceConfiguration.timeline[0].isSelected === true) {
      setAllChildEventTokens((pre) => {
        pre.forEach((ele, index) => {
          pre[index].isSelected = true;
          pre[index].attendance = true;
        })
        return [...pre]
      })
    }
  }

  function deSelectAll() {
    if (attendanceConfiguration.timeline[0].isSelected === true) {
      setAllChildEventTokens((pre) => {
        pre.forEach((ele, index) => {
          pre[index].isSelected = false;
          pre[index].attendance = false;
        })
        return [...pre]
      })
    }
  }

  return (
    <div className={cssClasses.mainContainer}>
      <div style={{ height: "100%" }}>
        <div className={cssClasses.header}>
          <div className={cssClasses.titleWrapper}>
            <div className={cssClasses.title}>
              <p>Attendance Configuration</p>
            </div>
          </div>
          {/* <div className={}>
                    <div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </div> */}
        </div>
        <div className={cssClasses.content}>
          <div className={cssClasses.progressCardWrapper}>
            <div className={cssClasses.progressCard}>
              <ProgressCard
                defaultExpanded={false}
                image={attendanceConfiguration.image}
                totalProgress={attendanceConfiguration.totalProgress}
                currentProgress={attendanceConfiguration.currentProgress}
                timeline={attendanceConfiguration.timeline}
                cardTitle={attendanceConfiguration.title}
              />
            </div>
          </div>
          <div className={cssClasses.tabsWrapper}>
            <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
              <TabContext
                value={
                  attendanceConfiguration.timeline.find((f) => f.isSelected)
                    .value
                }
              >
                <TabsMenu
                  selectedColor={"#1570EF"}
                  selectedBackgroundColor={"#FFFFFF"}
                  stylesForTab={{
                    color: "#344054",
                    fontSize: "1.6rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "2.4rem",
                    padding: "0.8rem 1.2rem",
                    textTransform: "unset",
                    borderBottom: "1px solid #EAECF0",
                  }}
                  borderColor={"#1570EFs"}
                  stylesForWrapper={{
                    padding: "1.5rem 0",
                    background: "#FFFFFF",
                  }}
                  list={attendanceConfiguration.timeline}
                  value={
                    attendanceConfiguration.timeline.find((f) => f.isSelected)
                      .value
                  }
                  handleChange={(e, value) => {
                    // tabChanged(e, value)
                    searchParams.set("submenu", value);
                    setSearchParams(searchParams);
                  }}
                />
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Select Tokens For Attendance"}
                  index={0}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <SelectSalesCp
                      allChildRows={allChildEventTokens}
                      deSelectAll={deSelectAll}
                      selectAll={selectAll}
                      type={"Token"}
                      allColums={eventTokenGridColumns}
                      allRows={allChildEventTokens.filter((e) => {
                        return e.show === true;
                      })}
                      setSearchSalesCp={setSearchEventToken}
                    />
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Arrange Token"}
                  index={1}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div>
                      <div
                        style={{
                          backgroundColor: "#F9FAFB",
                          padding: "1.4rem",
                          fontFamily: "Roboto-Regular",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "1.2rem",
                          lineHeight: "2rem",
                          letterSpacing: "0.021rem",
                          color: "#5F6368",
                        }}
                      >
                        <p>Token Name</p>
                      </div>
                      <DragDropContext onDragEnd={onDragEnd.bind(this)}>
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {tokenOrder.map((item, index) => (
                                <Draggable
                                  key={item.id}
                                  draggableId={item.id}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "1.4rem",
                                          borderBottom: "1px solid #DADCE0",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: "#3C4043",
                                            fontFamily: "Roboto-Regular",
                                            fontStyle: "normal",
                                            fontWeight: "400",
                                            fontSize: "1.4rem",
                                            lineHeight: "2rem",
                                            letterSpacing: "0.02rem",
                                          }}
                                        >
                                          {" "}
                                          <span
                                            style={{
                                              color: "#1570EF",
                                              background:
                                                "rgb(21, 112, 239,0.1)",
                                              borderRadius: "50%",
                                              padding: "0.25rem 0.7rem",
                                              marginRight: "0.5rem",
                                            }}
                                          >
                                            {index}
                                          </span>{" "}
                                          {item.tokenId.name}
                                        </p>
                                        <img
                                          style={{
                                            width: "3rem",
                                            height: "3rem",
                                          }}
                                          src={dragdrop}
                                          alt=""
                                          srcset=""
                                        />
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Select Queue Order"}
                  index={1}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div>
                      <div
                        className={cssClasses.searchWrapper}
                        style={{ marginBottom: "1.6rem" }}
                      >
                        <SearchBar
                          placeholder={"Search by token name"}
                          search={(e) => {
                            setSearchToken(e.target.value);
                          }}
                          id={"algoSearch"}
                        />
                      </div>
                      {allChildEventTokens.filter((e) => {
                        return e.attendance === true && e.show === true;
                      }).length > 0 ? (
                        <div>
                          <div
                            style={{
                              backgroundColor: "#F9FAFB",
                              padding: "1.4rem",
                              fontFamily: "Roboto-Regular",
                              fontStyle: "normal",
                              fontWeight: "400",
                              fontSize: "1.2rem",
                              lineHeight: "2rem",
                              letterSpacing: "0.021rem",
                              color: "#5F6368",
                              display: "flex",
                            }}
                          >
                            <p style={{ flex: "1" }}>Token Name</p>
                            <p style={{ flex: "1" }}>Algorithm</p>
                          </div>
                          {allChildEventTokens
                            .filter((e) => {
                              return e.attendance === true && e.show === true;
                            })
                            .map((m, index) => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "1.4rem",
                                  borderBottom: "1px solid #EAECF0",
                                }}
                              >
                                <div style={{ flex: "1" }}>
                                  <p className={cssClasses.tokenName}>
                                    {m.tokenId.name}
                                  </p>
                                </div>
                                <div style={{ flex: "1" }}>
                                  {algos.map((ele) => (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Radio
                                        checked={
                                          m.algoId && m.algoId === ele.algoId
                                        }
                                        onChange={(e) => {
                                          setAllChildEventTokens((pre) => {
                                            console.log(pre, m);
                                            pre[
                                              pre.findIndex(
                                                (e) =>
                                                  e.eventTokenId ===
                                                  m.eventTokenId
                                              )
                                            ].algoId = ele.algoId;
                                            // pre.forEach((p, i) => { if (i !== index) { pre[i].algoId = null } });
                                            return [...pre];
                                          });
                                        }}
                                      />
                                      <p className={cssClasses.algoName}>
                                        {ele.algorithm}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div>
                          <p
                            style={{ fontSize: "1.4rem", textAlign: "center" }}
                          >
                            No Tokens Available
                          </p>
                        </div>
                      )}
                    </div>
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Select Cp/Sales"}
                  index={1}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div style={{ height: "100%" }}>
                      <div
                        style={{
                          marginTop: "1.4rem",
                          // height: "calc(100% - 7rem)",
                          height: "100%",
                        }}
                      >
                        {allChildGroups.length > 0 && (
                          <div style={{ margin: "2rem 0" }}>
                            <p
                              style={{
                                fontSize: "1.8rem",
                                fontFamily: "Inter-Medium",
                                marginBottom: "0.6rem",
                              }}
                            >
                              ALL GROUPS
                            </p>
                            {/* {allChildGroups.filter((e) => {
                              return e.tokenName === tokenFilter;
                            }).map((m, i) => ( */}
                            {allChildGroups.map((m, i) => (
                              <div>
                                <Accordion
                                  expanded={
                                    expanded === m.groupName ? true : false
                                  }
                                >
                                  <AccordionSummary
                                    expandIcon={
                                      <ExpandMoreIcon
                                        style={{
                                          width: "2.5rem",
                                          height: "2.5rem",
                                        }}
                                        onClick={() =>
                                          expanded === m.groupName
                                            ? setExpanded("")
                                            : setExpanded(m.groupName)
                                        }
                                      />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flex: "1",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          justifyContent: "flex-start",
                                          fontSize: "1.4rem",
                                          fontFamily: "Inter-Medium",
                                        }}
                                      >
                                        {m.groupName}
                                      </Typography>
                                      <DeleteIcon
                                        style={{
                                          width: "2.5rem",
                                          height: "2.5rem",
                                          color: "rgb(21, 112, 239)",
                                        }}
                                        onClick={() => deleteGrp(m, i)}
                                      />
                                    </div>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <Typography>
                                      {m?.leads?.length > 0 && (
                                        <div>
                                          {m?.leads?.map((ele, index) => (
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "3rem",
                                                justifyContent: "flex-start",
                                                fontSize: "1.4rem",
                                                fontFamily: "Inter-Regular",
                                                padding: "1rem",
                                                borderBottom:
                                                  "1px solid rgba(0, 0, 0, 0.1)",
                                              }}
                                            >
                                              <p style={{ flex: "1" }}>
                                                Lead : {ele.leadName}
                                              </p>
                                              <p style={{ flex: "1" }}>
                                                Cp :{" "}
                                                {ele.cpName ? ele.cpName : "-"}
                                              </p>
                                              <p style={{ flex: "1" }}>
                                                Sales : {ele.salesName}
                                              </p>
                                              <p
                                                style={{ color: "red", cursor: "pointer" }}
                                                onClick={() => {
                                                  deleteLeadFromGrp(
                                                    m,
                                                    i,
                                                    ele,
                                                    index
                                                  );
                                                }}
                                              >
                                                Delete
                                              </p>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </Typography>
                                  </AccordionDetails>
                                </Accordion>
                              </div>
                            ))}
                          </div>
                        )}
                        {/* <div style={{ height: "calc(100% - 10rem)" }}> */}
                        <div style={{ height: "100%" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "1rem",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "1.8rem",
                                fontFamily: "Inter-Medium",
                                marginBottom: "0.6rem",
                              }}
                            >
                              ALL LEADS
                            </p>
                            <div>
                              <Button
                                clicked={groupLeads}
                                btnName={"Group"}
                                style={{
                                  borderRadius: "0.4rem",
                                  backgroundColor: "#1570EF",
                                  color: "#FFFFFF",
                                  fontSize: "1.6rem",
                                }}
                                padding={"0.5rem 1rem"}
                              />
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexDirection: "row",
                              flexWrap: "wrap",
                            }}
                          >
                            <div>
                              <DropDown
                                style={{
                                  selectedColor: "#667085",
                                  background: "#F1F3F4",
                                }}
                                list={allEventTokens}
                                selectedValue={tokenFilter}
                                onChangeSelect={(e) => {
                                  setTokenFilter(e);
                                  if (
                                    childLeadList.filter((e) => {
                                      return e.isSelected === true;
                                    }).length > 0 ||
                                    leadList.filter((e) => {
                                      return e.isSelected === true;
                                    }).length > 0
                                  ) {
                                    setTokenChanged(true);
                                  }
                                }}
                                placeHolder={"Select Token"}
                              />
                            </div>
                            <SearchBar
                              placeholder={"Search By Lead Name"}
                              search={(e) => {
                                setSearchLead(e.target.value);
                              }}
                            />
                          </div>
                          <div className={cssClasses.gridWrapper}>
                            <Datagrid
                              columns={leadColumns}
                              rows={[...childLeadList]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Change Priority"}
                  index={1}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div>
                      <div
                        style={{
                          backgroundColor: "#F9FAFB",
                          padding: "1.4rem",
                          fontFamily: "Roboto-Regular",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "1.2rem",
                          lineHeight: "2rem",
                          letterSpacing: "0.021rem",
                          color: "#5F6368",
                        }}
                      >
                        <p>Group Name</p>
                      </div>
                      <DragDropContext onDragEnd={onGrpDrag.bind(this)}>
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {allChildGroups.map((item, index) => (
                                <Draggable
                                  key={item.groupId}
                                  draggableId={item.groupId}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "1.4rem",
                                          borderBottom: "1px solid #DADCE0",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: "#3C4043",
                                            fontFamily: "Roboto-Regular",
                                            fontStyle: "normal",
                                            fontWeight: "400",
                                            fontSize: "1.4rem",
                                            lineHeight: "2rem",
                                            letterSpacing: "0.02rem",
                                          }}
                                        >
                                          {" "}
                                          <span
                                            style={{
                                              color: "#1570EF",
                                              background:
                                                "rgb(21, 112, 239,0.1)",
                                              borderRadius: "50%",
                                              padding: "0.25rem 0.7rem",
                                              marginRight: "0.5rem",
                                            }}
                                          >
                                            {index}
                                          </span>{" "}
                                          {item.groupName}
                                        </p>
                                        <img
                                          style={{
                                            width: "3rem",
                                            height: "3rem",
                                          }}
                                          src={dragdrop}
                                          alt=""
                                          srcset=""
                                        />
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </Box>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        </div>
      </div>
      <div className={cssClasses.footer}>
        <div
          className={cssClasses.btnWrapper}
          style={{ marginBottom: "1.6rem" }}
        >
          {attendanceConfiguration.timeline[0].isSelected !== true && (
            <Button
              clicked={() => {
                setAttendanceConfiguration((pre) => {
                  let index = attendanceConfiguration.timeline.findIndex(
                    (e) => e.isSelected === true
                  );
                  pre.timeline[index].isSelected = false;
                  pre.timeline[index - 1].isSelected = true;
                  searchParams.set(
                    "submenu",
                    attendanceConfiguration.timeline[index - 1].value
                  );
                  setSearchParams(searchParams);
                  return { ...pre };
                });
                setSearchEventToken("");
                setSearchLead("");
                setSearchToken("");
              }}
              btnName={"Back Step"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#D0D5DD",
                color: "#FFFFFF",
                fontSize: "1.6rem",
              }}
              padding={"0.5rem 1rem"}
              iconPosition={"left"}
            />
          )}
        </div>
        <div
          className={cssClasses.btnWrapper}
          style={{ marginBottom: "1.6rem" }}
        >
          <Button
            clicked={nextStep}
            btnName={"Save & Next Step"}
            style={{
              borderRadius: "0.4rem",
              backgroundColor: "#1570EF",
              color: "#FFFFFF",
              fontSize: "1.6rem",
            }}
            padding={"0.5rem 1rem"}
            iconPosition={"left"}
          />
        </div>
      </div>
      {openAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            ModalResp(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenAlert(false)}
          title={"Warning"}
          subTitle={"Unsaved Changes! Do you want to continue without saving"}
          open={openAlert}
        />
      )}
      {tokenChanged && (
        <ConfirmationAlert
          confirm={(e) => {
            changeToken(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setTokenChanged(false)}
          title={"Warning"}
          subTitle={
            "Unsaved Changes! Do you want to continue without saving, selected Leads will be unchecked"
          }
          open={tokenChanged}
        />
      )}
      {groupNameModal && (
        <GroupNameModal
          allChildGroups={allChildGroups.filter((e) => {
            return e.tokenName === tokenFilter;
          })}
          createGroup={createGroup}
          handleClose={() => {
            setGroupNameModal(false);
          }}
          open={groupNameModal}
          groupName={groupName}
          setGroupName={setGroupName}
        />
      )}
    </div>
  );
}
